export default "__VITE_ASSET__DCGz4wKJ__"